@if (currentUser$ | async; as currentUser) {
  <div class="flex flex-col lg:flex-row">
    @if (shop) {
      @if (shop.isVerified && currentUser.referralType === referralTypes.autovitals) {
        <mg-autovitals-menu></mg-autovitals-menu>
      }
    }
    <div class="flex-1 min-h-screen flex flex-col">
      <div class="flex-1 flex flex-col">
        <div class="lg:hidden print:hidden">
          @switch (currentUser.role) {
            @case (allRoles.user) {
              <mg-main-header
                [mainMenuRoutes]="userMainRoutes"
                [profileMenuRoutes]="userProfileRoutes"
              ></mg-main-header>
            }
            @case (allRoles.enterpriseuser) {
              <mg-main-header
                [mainMenuRoutes]="enterpriseMainRoutes"
                [profileMenuRoutes]="enterpriseProfileRoutes"
              ></mg-main-header>
            }
          }
        </div>
        <div class="content-container overflow-hidden print:overflow-visible relative">
          <div class="side-menu">
            @switch (currentUser.role) {
              @case (allRoles.user) {
                <mg-side-menu [mainMenuRoutes]="userMainRoutes"></mg-side-menu>
              }
              @case (allRoles.enterpriseuser) {
                <mg-side-menu [mainMenuRoutes]="enterpriseMainRoutes"></mg-side-menu>
              }
            }
          </div>
          <div id="main-content-container" class="main-content-container">
            <mg-top-menu
              [profileMenuRoutes]="
                currentUser.role === allRoles.enterpriseuser
                  ? enterpriseProfileRoutes
                  : userProfileRoutes
              "
            ></mg-top-menu>
            <div id="main-content" class="main-content beautyScroll">
              <router-outlet></router-outlet>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
